module.exports = __webpack_public_path__ + "static/media/logoSquare.05b1d1a7.png";